import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateReports } from '../../../../redux/actions/Diagnostics/diagnostics'
import Input from '../../../../UIComponents/Input/Input'
import ReportFooter from '../ReportFooter'
import { TestReportRightSection } from '../TestReportRightSection'
import './BilirubinDirectIndirect.css'


export const BilirubinDirectIndirect = () => {
    const dispatch =  useDispatch()
    const indexValue = useSelector(state => state?.diagnosticsInvoiceSummary?.indexValue)
    const reportDataFields = useSelector(state => state?.diagnosticsInvoiceSummary?.getdiagnostic)
    const [ inputValue, setInputValue ] = useState("")
    
    const onInputChange = (e,i) => {
      const { value, name } = e.target;
      const filterData = reportDataFields?.testReport?.filter(item => item?.test === 'BILIRUBIN DIRECT & INDIRECT')
      let index = 0
      reportDataFields?.testReport?.map((item, i) => {
        if(item.test === 'BILIRUBIN DIRECT & INDIRECT'){
          index = i
        }
        return item
      })
      console.log("index",index);
      const finalFilteredData = filterData[0]?.fields?.map((item,index) => {
        if(item.particular === name && index === i){
          item.result = value
        }
        return item
      })
      filterData[0].fields =  finalFilteredData
      reportDataFields.testReport[index]  = filterData[0]
      setInputValue(reportDataFields?.testReport[index]?.fields)
      dispatch(updateReports(reportDataFields))
    }
   
    return (
        <div>
            <div className='bil-main'>
                <div className='bil-container'>
                    <div className='bil-grid-container'>
                        <div className='bil-1 padd'>BIO CHEMICAL TEST</div>
                        <div className='bil-2 padd'>TOTAL BILIRUBIN</div>
                        <Input className='bil-input1 bilinputs' type="number" value={reportDataFields?.testReport?.[indexValue]?.fields?.[0]?.result} disabled={!reportDataFields.active}  name="TOTAL BILIRUBIN" onChange={(e)=>onInputChange(e,0)} />
                        <div className='bil-3 padd'>mg/dl</div>
                        <div className='bil-4 padd'>0.1-1.2</div>
                        <div className='bil-5 padd'></div>
                        <div className='bil-6 padd'></div>
                        <span className='bil-border1'></span>
                        <div className='bil-7 padd'>BIO CHEMICAL TEST</div>
                        <div className='bil-8 padd'>DIRECT BILIRUBIN</div>
                        <Input className='bil-input2 bilinputs' type="number" value={reportDataFields?.testReport?.[indexValue]?.fields?.[1]?.result} disabled={!reportDataFields.active} name="DIRECT BILIRUBIN" onChange={(e)=>onInputChange(e,1)} />
                        <div className='bil-9 padd'>mg/dl</div>
                        <div className='bil-10 padd'>0.1-1.2</div>
                        <div className='bil-11 padd'></div>
                        <div className='bil-12 padd'></div>
                        <span className='bil-border2'></span>
                        <div className='bil-13 padd'>BIO CHEMICAL TEST</div>
                        <div className='bil-14 padd'>INDIRECT BILIRUBIN</div>
                        <Input className='bil-input3 bilinputs' type="number" name="INDIRECT BILIRUBIN" value={reportDataFields?.testReport?.[indexValue]?.fields?.[2]?.result} disabled={!reportDataFields.active} onChange={(e)=>onInputChange(e,2)} />
                        <div className='bil-15 padd'>mg/dl</div>
                        <div className='bil-16 padd'>0.1-1.2</div>
                        <div className='bil-17 padd'></div>
                        <div className='bil-18 padd'></div>
                        <span className='bil-border3'></span>
                    </div>
                </div>
                <div className='bgroup-right-sec'>
                    <TestReportRightSection />
                </div>
            </div>
            <br></br>
            <div className='ivf-footer'>
                <ReportFooter />
            </div>
        </div>
    )
}
